import "core-js/modules/es.error.cause.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue";
import { ref, watch } from 'vue';
// eslint-disable-next-line
import { useVModel } from '@vueuse/core';
const TYPE_OPTIONS = ['', 'sms', 'account', 'fs'];
export default {
  __name: 'AccountSearch',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      validator: function (value) {
        const flag = TYPE_OPTIONS.includes(value);
        if (flag) {
          return true;
        } else {
          throw new Error(`值应该在${TYPE_OPTIONS.join(',')}中`);
        }
      }
    },
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'changeKeyword', 'changeValue'],
  setup(__props, {
    emit: __emit
  }) {
    // eslint-disable-next-line
    const props = __props;
    const radio = ref('');
    watch(() => props.value, val => {
      if (val) radio.value = val;
    });
    const keyword = ref('');
    const emits = __emit;
    const isVisible = useVModel(props);
    const handleChange = val => {
      emits('changeValue', val);
      isVisible.value = false;
    };
    watch([keyword, () => props.type], val => {
      emits('changeKeyword', val[0]);
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.type === 'sms' ? '选择短信账号' : __props.type === 'account' ? '选择公众号号' : '选择飞书账号',
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event)
        }, null, 8, ["modelValue"]), _withDirectives((_openBlock(), _createBlock(_component_el_radio_group, {
          modelValue: radio.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => radio.value = $event),
          style: {
            "margin-top": "20px"
          },
          onChange: handleChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, item => {
            return _openBlock(), _createBlock(_component_el_radio, {
              label: item.value,
              key: item.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])), [[_directive_loading, __props.loading]])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};